import axios from 'axios'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const RECEIVE_OLDER_DEPENDENTS = 'RECEIVE_OLDER_DEPENDENTS'
export const REQUEST_OLDER_DEPENDENTS = 'REQUEST_OLDER_DEPENDENTS'
const CREATE_OLDER_DEPENDENT = 'CREATE_OLDER_DEPENDENT'
const SAVE_OLDER_DEPENDENT = 'SAVE_OLDER_DEPENDENT'
const REMOVE_AND_DELETE_OLDER_DEPENDENT = 'REMOVE_AND_DELETE_OLDER_DEPENDENT'
export const REMOVE_OLDER_DEPENDENT = 'REMOVE_OLDER_DEPENDENT'
const DELETE_OLDER_DEPENDENT = 'DELETE_OLDER_DEPENDENT'

export const requestOlderDependents = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_OLDER_DEPENDENTS })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/olderdependents/?userId=${userId}`)
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveOlderDependents({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveOlderDependents({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveOlderDependents({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveOlderDependents = (data) => ({ type: RECEIVE_OLDER_DEPENDENTS, data })

export const createOlderDependent = (data) => (dispatch, getState) => {
    dispatch({ type: CREATE_OLDER_DEPENDENT, data })

    const { id: userId } = getState().profile

    return axios
        .post(`/olderdependents`, { ...data, userId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveOlderDependents({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveOlderDependents = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_OLDER_DEPENDENT, data })

    const { id: userId } = getState().profile

    const { id } = data

    return axios
        .put(`/olderdependents/${id}`, { ...data, userId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveOlderDependents({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const removeAndDeleteOlderDependent = (data) => (dispatch) => {
    dispatch({ type: REMOVE_AND_DELETE_OLDER_DEPENDENT, data })

    dispatch(removeOlderDependent(data))
    return dispatch(deleteOlderDependent(data))
}

const removeOlderDependent = (data) => ({ type: REMOVE_OLDER_DEPENDENT, data })

const deleteOlderDependent = (data) => (dispatch) => {
    dispatch({ type: DELETE_OLDER_DEPENDENT, data })

    const { id } = data

    return axios
        .delete(`/olderdependents/${id}`)
        .then(() => {
            dispatch(removeOlderDependent({ id }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
        })
}
